import React, { useState, useEffect, useRef } from "react";
import "./Comment.css";
import Swal from "sweetalert2";
import axios from "axios";
// import Editor from "../Dashboard/Editor";
import { getServerBaseUrl } from "../../utils/portConfig";
import DoctorMale from "../../assets/images/doctor-male.png";
import { set } from "date-fns";
import CommentTextarea from "./CommentTextarea";
import * as detailsDateFormat from "../Util/DateFormat";

const CommunityCommentList = ({ postId, commentList, getNoticeDetails, setCommentList, userid, setDocorSettingOpen }) => {
  const [isEditComment, setIsEditComment] = useState(false);
  const [isCreateComment, setIsCreateComment] = useState(false);
  const [selectComment, setSelectComment] = useState({});
  const [answerContent, setAnswerContent] = useState("");
  const API_SERVER_V2_URL = `${getServerBaseUrl()}/api/v2`; // API 서버 URL

  //creanup
  useEffect(() => {
    return () => {
      setIsEditComment(false);
      setIsCreateComment(false);
      setSelectComment({});
      setAnswerContent("");
    };
  }, [postId]);

  // 댓글 등록
  const onClickAnswer = async () => {
    try {
      const response = await axios.post(`${API_SERVER_V2_URL}` + `/community/${postId}/comment`, {
        content: answerContent.trim(),
      });

      if (response.status === 200) {
        getNoticeDetails();
        setIsCreateComment(false);
        setAnswerContent("");
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "댓글 등록 실패. 다시 시도해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("Error creating comments: ", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "댓글 등록 오류",
            text: responseData.message,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  const onChangeAnswer = (e) => {
    const { value } = e.target;
    setAnswerContent(value);
  };

  const onChangeEditComment = (e) => {
    const { value } = e.target;
    setSelectComment((prev) => ({ ...prev, content: value }));
  };

  const deleteComment = (commentId) => async () => {
    const confirmationResult = await Swal.fire({
      icon: "question",
      title: "댓글 삭제",
      text: "댓글을 삭제하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      customClass: {
        popup: "custom-swal-popup",
      },
    });

    if (confirmationResult.isConfirmed) {
      try {
        const response = await axios.delete(`${API_SERVER_V2_URL}/community/${postId}/comment/${commentId}`);

        if (response.status === 200) {
          const newList = commentList.filter((item, i) => item.id !== commentId);
          setCommentList(newList);
          getNoticeDetails();
        } else {
          await Swal.fire({
            icon: "error",
            title: "실패",
            text: "삭제 실패. 다시 시도해주세요.",
            confirmButtonText: "확인",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } catch (error) {
        console.error("Error deleting comment:", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            Swal.fire({
              icon: "error",
              title: "댓글 삭제 오류",
              text: responseData.message,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답 오류",
              text: `서버 응답 오류: ${error.response.status}`,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답이 없습니다.",
            text: "서버 응답이 없습니다.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      }
    }
  };

  const editComment = async (commentId) => {
    const confirmationResult = await Swal.fire({
      icon: "question",
      title: "댓글 수정",
      text: "댓글을 수정하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      customClass: {
        popup: "custom-swal-popup",
      },
    });

    if (confirmationResult.isConfirmed) {
      try {
        const response = await axios.put(`${API_SERVER_V2_URL}/community/${postId}/comment/${commentId}`, {
          content: selectComment.content.trim(), // 수정할 내용
        });

        if (response.status === 200) {
          const newList = commentList.map((item) => {
            if (item.id === commentId) {
              return {
                ...item,
                content: selectComment.content.trim(), // 수정된 내용으로 업데이트
              };
            }
            return item;
          });
          setCommentList(newList);
          setIsEditComment(false);
          setSelectComment("");
        } else {
          await Swal.fire({
            icon: "error",
            title: "실패",
            text: "수정 실패. 다시 시도해주세요.",
            confirmButtonText: "확인",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } catch (error) {
        console.error("Error deleting comment:", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            Swal.fire({
              icon: "error",
              title: "댓글 수정 오류",
              text: responseData.message,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답 오류",
              text: `서버 응답 오류: ${error.response.status}`,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답이 없습니다.",
            text: "서버 응답이 없습니다.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      }
    }
  };

  const nicknameCheck = async () => {
    try {
      const response = await axios.get(`${API_SERVER_V2_URL}/user`);
      if (response.status === 200) {
        if (!response.data.data.nickname) {
          Swal.fire({
            icon: "warning",
            title: "닉네임을 설정해주세요.",
            confirmButtonText: "확인",

            customClass: {
              popup: "custom-swal-popup",
            },
          }).then(() => {
            setDocorSettingOpen(true); // 닉네임 설정 팝업 열기
          });

          return;
        } else {
          setIsCreateComment(true);
          setIsEditComment(false);
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "유저정보 조회 실패",
          text: "유저정보를 가져오는 데 실패했습니다. 다시 시도해주세요.",
        });
      }
    } catch (error) {
      console.error("Error get PatientCommunityDetailData:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "데이터 로딩 중 오류 발생",
            text: responseData.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  };

  const cancelCreateComment = () => {
    setIsCreateComment(false);
    setAnswerContent("");
  };

  return (
    <div className="comment-list-container">
      <div className="comment-list-container">
        <label>답변</label>
        <span className="comments-cnt">
          <span> {commentList.length}</span> 개
        </span>
        <div className="comments-button-container" style={{ marginBottom: commentList.length > 0 && "5px" }}>
          {!isCreateComment && (
            <button style={{ backgroundColor: "#333" }} onClick={nicknameCheck}>
              답변하기
            </button>
          )}
        </div>

        {isCreateComment && (
          <div className="answer-comment-container">
            {/*
            <div className="content-detail-quill-container"> <Editor ref={editorRef} readOnly={isReadOnly} initialHTML={bbsDetailData.contents} /> </div>*/}
            <CommentTextarea value={answerContent} onChange={onChangeAnswer} minHeight={100} />
            <div className="answer-button-container">
              <button style={{ backgroundColor: "#333" }} onClick={onClickAnswer}>
                등록
              </button>
              <button onClick={cancelCreateComment}>취소</button>
            </div>
          </div>
        )}
        {commentList.length > 0 && <hr />}

        {commentList.map((item, index) => (
          <div className="comments-container" key={index}>
            <div className="comments-top-container">
              <div className="comments-top-left">
                <img src={item.profileImg?.thumbnailUrl || DoctorMale} alt="프로필 이미지" className="comments-profile-image" />
                <div>
                  <div className="date-font-style">
                    <span style={{ color: "black" }}>{item.nickname}</span> <span>{item.hospitalName ?? ""}</span>
                  </div>
                  <div className="date-font-style">
                    <span>{detailsDateFormat.formatKoreanDateTime(item.createdDt ?? "")}</span>
                  </div>
                </div>
              </div>
            </div>
            {isEditComment && selectComment.id === item.id ? (
              <CommentTextarea value={selectComment.content} onChange={onChangeEditComment} minHeight={100} />
            ) : (
              <div className="community-comment">{item.content}</div>
            )}

            {item.mine ? (
              <div className="comments-button-container">
                <>
                  {isEditComment && selectComment.id === item.id ? (
                    <>
                      {/* 수정 중*/}
                      <button
                        onClick={() => {
                          editComment(item.id);
                        }}
                        style={{ backgroundColor: "#333" }}
                      >
                        등록
                      </button>
                      <button
                        onClick={() => {
                          setIsEditComment(false);
                          setSelectComment(null);
                        }}
                      >
                        취소
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          setIsEditComment(true);
                          setIsCreateComment(false);
                          setSelectComment(item);
                        }}
                      >
                        수정
                      </button>
                      <button style={{ backgroundColor: "red" }} onClick={deleteComment(item.id)}>
                        삭제
                      </button>
                    </>
                  )}
                </>
              </div>
            ) : (
              ""
            )}
            {commentList.length !== index + 1 && <div className="comments-border" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunityCommentList;
